var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomMeetingsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Meetings",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.7991 58.7991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0b5cff;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -2879.32492,
    cy: -184.8774,
    fx: -2879.32492,
    fy: -184.8774,
    r: 2.09996,
    gradientTransform: "translate(54378.67285 2942.59042) scale(18.8757 15.7759)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#365cfa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#233ead"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -2879.28472,
    cy: -184.63298,
    fx: -2879.28472,
    fy: -184.63298,
    r: 2.10001,
    gradientTransform: "translate(54358.33582 2944.50313) scale(18.8689 15.7702)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#365cfa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80a2ed"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.7991,29.39955c0,3.14386-.25199,6.22661-.73494,9.23251-1.59817,9.95091-9.48138,17.83313-19.43316,19.43142-3.00499.48278-6.08778.73562-9.23145.73562s-6.22646-.25283-9.23145-.73562c-9.95177-1.59829-17.83498-9.48051-19.43316-19.43142-.48295-3.00589-.73494-6.08864-.73494-9.23251s.25199-6.22661.73494-9.23251C2.33311,10.21614,10.21632,2.33391,20.1681.73562c3.00499-.48278,6.08778-.73562,9.23145-.73562s6.22646.25283,9.23145.73562c9.95177,1.59829,17.83498,9.48051,19.43316,19.43142.48295,3.00589.73494,6.08864.73494,9.23251Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.7991,29.39955c0,3.14386-.25199,6.22661-.73494,9.23251-1.59817,9.95091-9.48138,17.83313-19.43316,19.43142-3.00499.48278-6.08778.73562-9.23145.73562s-6.22646-.25283-9.23145-.73562c-9.95177-1.59829-17.83498-9.48051-19.43316-19.43142-.48295-3.00589-.73494-6.08864-.73494-9.23251s.25199-6.22661.73494-9.23251C2.33311,10.21614,10.21632,2.33391,20.1681.73562c3.00499-.48278,6.08778-.73562,9.23145-.73562s6.22646.25283,9.23145.73562c9.95177,1.59829,17.83498,9.48051,19.43316,19.43142.48295,3.00589.73494,6.08864.73494,9.23251Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.7991,29.39955c0,3.14386-.25199,6.22661-.73494,9.23251-1.60023,9.95091-9.48138,17.83313-19.43316,19.43142-3.00499.48278-6.08778.73562-9.23145.73562s-6.22646-.25283-9.2335-.73562c-9.94972-1.59829-17.83293-9.48051-19.43111-19.43142-.48295-3.0061-.73494-6.08864-.73494-9.23251,0-3.14365.25199-6.22661.73494-9.23272C2.33311,10.21614,10.21632,2.3337,20.16605.73541,23.17309.25263,26.25588,0,29.39955,0s6.22646.25263,9.23145.73541c9.95177,1.59828,17.83498,9.48072,19.43316,19.43142.48295,3.00611.73494,6.08886.73494,9.23272Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.69945,36.74944c0,1.73961-1.41117,3.14995-3.14995,3.14995h-13.64979c-3.47961,0-6.2999-2.82047-6.2999-6.2999v-11.54982c0-1.73961,1.41117-3.14995,3.14995-3.14995h13.64979c3.47961,0,6.2999,2.82047,6.2999,6.2999v11.54982ZM43.6793,20.78947l-4.61995,3.46495c-.79377.59492-1.25993,1.52857-1.25993,2.51996v5.24992c0,.9916.46616,1.92504,1.25993,2.51996l4.61995,3.46494c1.03742.77867,2.51999.03801,2.51999-1.25998v-14.69977c0-1.29778-1.48256-2.03865-2.51999-1.25998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomMeetingsLogo);
export default __webpack_public_path__ + "static/media/zoom-meetings-logo.7424c8c51ab5891b753f99ff0e592b88.svg";
export { ForwardRef as ReactComponent };